import React, { useState, useEffect } from 'react'
import ImageGallery from 'react-image-gallery'
import { isMobile } from 'react-device-detect'
import "react-image-gallery/styles/scss/image-gallery.scss"
import '../../../../assets/css/app.css'

const Banners = (props) => {
  const [images, setImages] = useState([])

  useEffect(() => {
    const imagesArray = []
    props.images.map(image => {
      const item = {
        original: `https://storage.googleapis.com/vendora-storage/banners/${image.image}`,
        bulletClass: 'banners-bullets',
        link: image.link,
        renderItem: () => {
          return (<div style={{ border: '1px solid #f2f2f2', borderRadius: '15px' }}>
            <a href={item.link} rel="noopener noreferrer">
              <img
                className='image-gallery-image'
                style={{ height: isMobile ? 'auto' : '300px',
                borderRadius: '12px' }}
                src={item.original}
                alt=""
              />
            </a>
          </div>)
        }
      }
      imagesArray.push(item)
      return true
    })
    setImages(imagesArray)
  }, [props.images]) // eslint-disable-line

  return (
    <React.Fragment>
      <ImageGallery
        autoPlay
        showPlayButton={false}
        showFullscreenButton={false}
        items={images}
        slideInterval={8000}
        showNav={false}
        showBullets
        showThumbnails={false}
        infinite
      />
    </React.Fragment>
  )
}

export default Banners